import { takeLatest, put, call } from 'redux-saga/effects';
import * as MeteringSystemData from './action';
import * as CorporateListAction from './action';
import request from '../../components/Utils/httpHelper';
import { CORE_API} from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER} from '../../constants';

export function* uploadMeteringSystemExcelFile(action) {
    let requestUrl = `${CORE_API}/meteringsystem/upload`;
    try {
        const formData = new FormData();
        formData.append('File', action.data.file);
        const createResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(MeteringSystemData.excelUploadMeteringSystemSuccess(createResult));
    } catch (err) {
        yield put(MeteringSystemData.excelUploadMeteringSystemFailure(err))
    }
}

export function* uploadMeteringExcelFile() {
    yield takeLatest(MeteringSystemData.UPLOAD_METERING_SYSTEM, uploadMeteringSystemExcelFile);
}

export function* downloadExcel(action) {
    let requestUrl = `${CORE_API}/meteringsystem/download`;
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'GET', headers: HTTP_HEADERS,responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  } );
        yield put(MeteringSystemData.downloadExcelFileSuccess(createResult));
    } catch (err) {
        yield put(MeteringSystemData.downloadExcelFileFailure(err))
    }
}

export function* downloadExcelFile() {
    yield takeLatest(MeteringSystemData.DOWNLOAD_EXCEL_FILE, downloadExcel);
}

export function* meteringSystem(action) {
    let requestUrl = `${CORE_API}/meteringsystem/getBulkUploadData/${action.data.pageNumber}/${action.data.pageSize}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(MeteringSystemData.meteringSystemDataSuccess(createResult.data));
    } catch (err) {
        yield put(MeteringSystemData.meteringSystemDataFailure(err))
    }
}
export function* meteringSystemData() {
    yield takeLatest(MeteringSystemData.METERING_SYSTEM_DATA, meteringSystem);
}

export function* meteringSystemExcelFileDownload(action) {
    let requestUrl = `${CORE_API}/meteringsystem/s3/`;
    requestUrl=requestUrl + action.data.fileKey
    // let requestUrl = `${CORE_API}/meteringsystem/s3/6dc3a8e1-4818-42db-b6d5-e654dd2542ee.xlsx`
    try {
        const createResult = yield call(request, requestUrl, {data:action.data, method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(MeteringSystemData.meteringSystemExcelDownloadSuccess(createResult));
        downloadExcel(createResult)
    } catch (err) {
        yield put(MeteringSystemData.meteringSystemExcelDownloadFailure(err))
    }
}
export function* meteringSystemExcelDownloadFile() {
    yield takeLatest(MeteringSystemData.METERING_SYSTEM_EXCEL_DOWNLOAD, meteringSystemExcelFileDownload);
}

export function* checkAgreementStatusSaga(action) {
    let requestUrl = `${CORE_API}/meteringsystem/agreement-status`;
    try {
        const formData = new FormData();
        formData.append('File', action.data.file);
        const createResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(MeteringSystemData.checkAgreementStatusSuccess(createResult));
    } catch (err) {
        yield put(MeteringSystemData.checkAgreementStatusFailure(err));
    }
}

export function* checkAgreementStatus() {
    yield takeLatest(MeteringSystemData.CHECK_AGREEMENT_STATUS, checkAgreementStatusSaga);
}

export function* notifySalesAssociateSaga(action) {
    let requestUrl = `${CORE_API}/meteringsystem/agreement-status/notify`;
    try {
        const formData = new FormData();
        formData.append('File', action.data.file);
        const result = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(MeteringSystemData.notifySalesAssociateSuccess(result.data));
    } catch (err) {
        yield put(MeteringSystemData.notifySalesAssociateFailure(err));
    }
}

export function* notifySalesAssociate() {
    yield takeLatest(MeteringSystemData.NOTIFY_SALES_ASSOCIATE, notifySalesAssociateSaga);
}

export function* fetchMailConfigSaga() {
    let requestUrl = `${CORE_API}/meteringsystem/mail-config`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(MeteringSystemData.fetchMailConfigSuccess(result.data));
    } catch (err) {
        yield put(MeteringSystemData.fetchMailConfigFailure(err.response && err.response.data ? err.response.data : err));
    }
}

export function* fetchMailConfig() {
    yield takeLatest(MeteringSystemData.FETCH_MAIL_CONFIG, fetchMailConfigSaga);
}

export function* saveMailConfigSaga(action) {
    let requestUrl = `${CORE_API}/meteringsystem/mail-config`;
    const method = action.id ? 'PUT' : 'POST';
    if (action.id) {
        requestUrl = `${requestUrl}/${action.id}`;
    }
    try {
        const result = yield call(request, requestUrl, { data: action.data, method, headers: HTTP_HEADERS });
        yield put(MeteringSystemData.saveMailConfigSuccess(result.data));
    } catch (err) {
        const message = (err.response && err.response.data && err.response.data.message)
            || 'Failed to save email template config';
        yield put(MeteringSystemData.saveMailConfigFailure(message));
    }
}

export function* saveMailConfig() {
    yield takeLatest(MeteringSystemData.SAVE_MAIL_CONFIG, saveMailConfigSaga);
}

export function* checkTransactionData(action) {
    let requestUrl = `${CORE_API}/corporate/transaction/data/checkexists`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(CorporateListAction.transactionDataCheckSuccess(createResult.data));
    } catch (err) {
        yield put(CorporateListAction.transactionDataCheckFailure(err))
    }
}